<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Criar condomínio</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-stepper #stepper [linear]="true">
        <!-- Passo 1: Cadastro -->
        <mat-step>
          <ng-template matStepLabel>Cadastro</ng-template>
          <app-condominium-form [mode]="'create'" [showTermsAcceptance]="true" #formComp></app-condominium-form>
          <div class="button-container button-spacing">
            <button mat-raised-button color="accent" (click)="onBack()">Voltar</button>
            <button mat-raised-button color="primary" (click)="onNext()">Próximo</button>
          </div>
        </mat-step>

        <!-- Passo 2: Escolha do Plano -->
        <mat-step>
          <ng-template matStepLabel>Escolha do Plano</ng-template>
          <app-subscription-plan-selector 
            #planSelector
            (planSelected)="onPlanSelected($event)">
          </app-subscription-plan-selector>
          <div class="button-container button-spacing">
            <button mat-raised-button color="accent" (click)="onBack()">Voltar</button>
            <button 
              mat-raised-button 
              color="primary" 
              (click)="onNext()"
              [disabled]="!selectedPlan || isCreating">
              @if (isCreating) {
                Criando...
              } @else {
                Criar e Prosseguir
              }
            </button>
          </div>
        </mat-step>

        <!-- Passo 3: Conclusão -->
        <mat-step>
          <ng-template matStepLabel>Conclusão</ng-template>
          <div class="payment-step">
            <p>Parabéns! Seu condomínio foi criado. Aproveite, o primeiro mês é grátis!</p>
            <button mat-raised-button color="primary" (click)="onGoToCondominium()">Ir para condomínio</button>
          </div>
        </mat-step>
      </mat-stepper>
    </mat-card-content>
  </mat-card>
</div>


